<app-loading uid="account-name-dialog-loading"
             class="loading"></app-loading>
<div class="modal-content">
  <div class="header-container">
    <div class="header-title">
      <i class="fas fa-pen"></i>
      <span>Nome personalizado</span>
    </div>
    <button mat-icon-button
            aria-label="Fechar"
            (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="description-container">
    Dê um nome fácil de lembrar para esta conta e a identifique rapidamente.
    Como contas podem ter nomes parecidos, esse nome ajuda você a
    diferenciá-las.
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Nome Personalizado</mat-label>
    <input matInput
           [formControl]="displayName" />

    <mat-error *ngIf="displayName.hasError('pattern')">
      O nome personalizado não aceita símbolos com exceção do hífen (-).
    </mat-error>

    <mat-error *ngIf="displayName.hasError('minlength') || displayName.hasError('maxlength')">
      O nome personalizado deve ter um tamanho mínimo de 4 e máximo de 50 caracteres.
    </mat-error>
  </mat-form-field>

  <div class="example-container">
    <p>Você está nomeando a conta:</p>
    <p>
      {{
      data.operatorConfigProfile?.userHolderTaxId?.length === 11
      ? "Conta Pessoal"
      : "Conta Empresarial"
      }}
      {{ getFormattedAccount() }}
    </p>
  </div>

  <div class="actions">
    <div class="button-basic-primary cancel-button"
         [ngClass]="{ 'disabled': isRemoveButtonDisabled }"
         (click)="!isRemoveButtonDisabled && onClick('remove')">
      Remover nome
    </div>

    <div class="button-basic-primary save-button"
         [ngClass]="{ 'disabled': isFormInvalid }"
         (click)="!isFormInvalid && onClick('save')">
      Salvar
    </div>
  </div>
</div>